import { VIEW } from '../../constants/appConstants'
import ActionTypes from '../actionTypes/actionTypes';

export const setFilter = (view, filter) => ({
    type: view === VIEW.WINDOW_LIST_VIEW ? ActionTypes.SET_FILTER_ALL_WINDOW 
        : view === VIEW.MY_WINDOW_VIEW ? ActionTypes.SET_FILTER_MY_WINDOW 
        : undefined,
    filter: filter
});